import { Box, Typography, Paper, Chip } from '@mui/material';
import { AddPhotoAlternate } from '@mui/icons-material';
import { useTranslation } from 'react-i18next';
import ImagePreview from './ImagePreview';
import '../../theme/newPost.css';

interface ImagesStepProps {
  existingImageUrls: string[];
  newImages: File[];
  maxImages: number;
  onAddImage: () => void;
  onRemoveExistingImage: (index: number) => void;
  onRemoveNewImage: (index: number) => void;
}

const ImagesStep: React.FC<ImagesStepProps> = ({
  existingImageUrls,
  newImages,
  maxImages,
  onAddImage,
  onRemoveExistingImage,
  onRemoveNewImage
}) => {
  const { t } = useTranslation();
  const totalImages = existingImageUrls.length + newImages.length;

  return (
    <Box className="new-post-step-content">
      <Box sx={{ 
        display: 'flex', 
        justifyContent: 'space-between', 
        alignItems: 'center',
        mb: 2
      }}>
        <Typography variant="body1" sx={{ fontWeight: 500 }}>
          {t('new_post.images_helper')}
        </Typography>
        <Chip 
          label={`${totalImages}/${maxImages}`}
          color={totalImages >= maxImages ? "primary" : "default"}
          size="small"
          sx={{ fontWeight: 'bold' }}
        />
      </Box>
      
      <div className="new-post-image-grid">
        {/* Add Image Button */}
        {totalImages < maxImages && (
          <Paper
            elevation={0}
            onClick={onAddImage}
            className="new-post-add-image"
          >
            <AddPhotoAlternate className="new-post-add-image-icon" />
            <Typography 
              variant="body2" 
              className="new-post-add-image-text"
            >
              {t('new_post.add_image')}
            </Typography>
          </Paper>
        )}
        
        {/* Existing Images */}
        {existingImageUrls.map((url, index) => (
          <ImagePreview
            key={`existing-${index}`}
            src={url}
            index={index}
            onRemove={() => onRemoveExistingImage(index)}
          />
        ))}

        {/* New Images */}
        {newImages.map((file, index) => (
          <ImagePreview
            key={`new-${index}`}
            src={URL.createObjectURL(file)}
            index={existingImageUrls.length + index}
            onRemove={() => onRemoveNewImage(index)}
          />
        ))}
      </div>
    </Box>
  );
};

export default ImagesStep;
